module.exports = __webpack_public_path__ + "img/logo_jia_white.fe410b42.png";